var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellQuestionSolidHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16Z",
    fill: "#4B68CF",
    stroke: "#4B68CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84473 11.5586C9.42969 11.5586 9.18555 11.2754 9.18555 10.875V10.8066C9.18555 10.2305 9.4834 9.84961 10.0596 9.5127C10.6895 9.13672 10.8799 8.89258 10.8799 8.44336C10.8799 7.96484 10.5088 7.63281 9.97168 7.63281C9.49316 7.63281 9.1709 7.86719 9.01465 8.30176C8.89258 8.61426 8.67285 8.75098 8.375 8.75098C7.98926 8.75098 7.75 8.51172 7.75 8.14062C7.75 7.93066 7.79883 7.74512 7.89648 7.55957C8.20898 6.91504 8.99023 6.5 10.04 6.5C11.4268 6.5 12.3594 7.26172 12.3594 8.39941C12.3594 9.13672 12.0029 9.63965 11.3145 10.0449C10.665 10.4209 10.5186 10.6309 10.4551 11.041C10.3818 11.3682 10.1914 11.5586 9.84473 11.5586ZM9.85449 13.7314C9.41504 13.7314 9.05859 13.3945 9.05859 12.9648C9.05859 12.5352 9.41504 12.1982 9.85449 12.1982C10.2988 12.1982 10.6553 12.5352 10.6553 12.9648C10.6553 13.3945 10.2988 13.7314 9.85449 13.7314Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellQuestionSolidHover);
export default __webpack_public_path__ + "static/media/icn_table_cell_Question_solid_hover.0e763cb70a9321d1ec4a81ea822d6ea9.svg";
export { ForwardRef as ReactComponent };